var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9761 7.10898L12.5438 9.90793H10.2721V16.7918H7.22544V9.90793H4.75V7.10898H7.22544V4.97573C7.22544 2.54935 8.68024 1.2085 10.9082 1.2085C11.9745 1.2085 13.0903 1.39761 13.0903 1.39761V3.7805H11.8603C10.6492 3.7805 10.2721 4.52753 10.2721 5.29345V7.10898H12.9761Z","fill":"black"}));
}

FacebookInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
